/*
 * PENCIL CLICKER CATALOG — THIS IS THE ONLY CATALOG FILE TO EDIT.
 *
 * IMPORTANT: Keep every entry disabled until you have confirmed that it is
 * included in the purchased model-file package and uploaded a reduced-detail
 * GLB/glTF preview. Never upload production STL/3MF files to Shopify Files.
 * See docs/SETUP.md for editing and model-export instructions.
 */
// After uploading the reduced GLBs to Shopify Files, paste the shared CDN folder URL here.
// Example: "https://cdn.shopify.com/s/files/1/0000/0000/files/"
var PENCIL_PREVIEW_BASE_URL = window.PencilPreviewAssetBase || "";
var PENCIL_ENABLE_LICENSED_DESIGNS = true;
var pencilPreviewModel = (filename) => PENCIL_PREVIEW_BASE_URL ? `${PENCIL_PREVIEW_BASE_URL}${filename}` : "";

// Simplified launch palette shared by the lead, blocks, designs, end cap, and eraser.
// `palette` controls the button swatch. `hex` is the representative 3D-preview tint.
var PENCIL_COLORS = [
  { id: "black", label: "Black", hex: "#000000", palette: ["#000000"], enabled: true },
  { id: "white", label: "White", hex: "#FFFFFF", palette: ["#FFFFFF"], enabled: true },
  { id: "grey", label: "Grey", hex: "#8E9089", palette: ["#8E9089"], enabled: true },
  { id: "blue", label: "Blue", hex: "#0A2989", palette: ["#0A2989"], enabled: true },
  { id: "red", label: "Red", hex: "#C12E1F", palette: ["#C12E1F"], enabled: true },
  { id: "orange", label: "Orange", hex: "#FF6A13", palette: ["#FF6A13"], enabled: true },
  { id: "yellow", label: "Yellow", hex: "#F4EE2A", palette: ["#F4EE2A"], enabled: true },
  { id: "galaxy-purple", label: "Galaxy Purple", hex: "#594177", palette: ["#34243F", "#594177", "#81709A"], enabled: true },
  { id: "galaxy-black", label: "Galaxy Black", hex: "#18181B", palette: ["#050505", "#20242B", "#777E8A"], enabled: true },
  { id: "peacock-blue", label: "Peacock Blue", hex: "#21606B", palette: ["#16454F", "#21606B", "#378895"], enabled: true },
  { id: "ice-blue", label: "Ice Blue", hex: "#8BD5EE", palette: ["#8BD5EE"], enabled: true },
  { id: "sakura-pink", label: "Sakura Pink", hex: "#E8AFCF", palette: ["#E8AFCF"], enabled: true },
  { id: "lilac-purple", label: "Lilac Purple", hex: "#AE96D4", palette: ["#AE96D4"], enabled: true },
  { id: "indigo-purple", label: "Indigo Purple", hex: "#482960", palette: ["#482960"], enabled: true },
  { id: "rainbow-1", label: "Rainbow 1", hex: "#B784A7", palette: ["#B784A7", "#F26B5B", "#F28C28", "#E4B94C", "#0B5D66"], enabled: true },
  { id: "rainbow-2", label: "Rainbow 2", hex: "#4169E1", palette: ["#00B7D9", "#4169E1", "#C2185B", "#7F3FBF"], enabled: true },
  { id: "rainbow-4", label: "Rainbow 4", hex: "#F5A3C7", palette: ["#F5A3C7", "#8E5BB7", "#FFFFFF"], enabled: true }
];

window.PencilClickerCatalog = {
  currencyCode: "USD",

  // These amounts must match the prices of the corresponding Shopify products.
  // Launch pricing: $5 includes the first block and either available ending.
  // Every additional block adds $2.
  basePriceCents: 500,
  additionalBlockPriceCents: 200,
  additionalBlockVariantId: "46289219158050",

  // Licensed product photography for the gallery. Upload approved copies to Shopify Files.
  productImages: [
    {
      src: pencilPreviewModel("photo-01.jpg"),
      alt: "Personalized modular pencil clicker keychains in assorted colors",
      enabled: true
    },
    {
      src: pencilPreviewModel("photo-05.jpg"),
      alt: "Modular pencil clicker blocks, pencil tip, ferrule, and eraser pieces",
      enabled: true
    }
  ],

  // Launch range: 1–10. Lower this if production testing finds a smaller physical limit.
  maximumBlocks: 10,

  // The exposed pencil lead/point can use any enabled launch-palette color.
  // Black is first so it remains the default traditional-pencil appearance.
  pencilColors: PENCIL_COLORS.map((color) => ({ ...color })),

  blockColors: PENCIL_COLORS.map((color) => ({ ...color })),
  // White is first so the initial black block has a visible contrasting design.
  designColors: PENCIL_COLORS
    .map((color) => ({ ...color }))
    .sort((a, b) => a.id === "white" ? -1 : b.id === "white" ? 1 : 0),

  designStyles: [
    { id: "raised", label: "Raised", enabled: true },
    { id: "flush", label: "Flush", enabled: true }
  ],

  pencilEndings: [
    { id: "single-color-stopper", label: "Single-color end cap", priceLabel: "$5 starting price", surchargeCents: 0, surchargeVariantId: "", enabled: true },
    { id: "eraser", label: "Pencil eraser end cap", priceLabel: "$5 starting price", surchargeCents: 0, surchargeVariantId: "", enabled: true }
  ],

  /*
   * Add only designs included in the licensed package. The samples below are
   * deliberately disabled. Use category: letter, number, symbol, or character.
   * supportsDesignColor controls whether the design-color control is shown.
   * surchargeVariantId must be a Shopify variant with the exact surcharge price.
   */
  // Confirmed from the purchased Clickify 3MF. Both Raised and Flat source variants
  // are included; the customer-facing name for the source's Flat style is Flush.
  letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((label) => ({
    id: label.toLowerCase(), label, thumbnail: "", models: {
      raised: pencilPreviewModel(`design-raised-${label.toLowerCase()}.glb`),
      flush: pencilPreviewModel(`design-flush-${label.toLowerCase()}.glb`)
    },
    supportsDesignColor: true, surchargeCents: 0, surchargeVariantId: "", enabled: PENCIL_ENABLE_LICENSED_DESIGNS
  })),

  numbers: "0123456789".split("").map((label) => ({
    id: `number-${label}`, label, thumbnail: "", models: {
      raised: pencilPreviewModel(`design-raised-number-${label}.glb`),
      flush: pencilPreviewModel(`design-flush-number-${label}.glb`)
    },
    supportsDesignColor: true, surchargeCents: 0, surchargeVariantId: "", enabled: PENCIL_ENABLE_LICENSED_DESIGNS
  })),

  symbolsOrCharacters: [
    ["at-sign", "@"], ["ampersand", "&"], ["butterfly", "Butterfly"], ["crown", "Crown"], ["equals", "="],
    ["exclamation-mark", "!"], ["flower", "Flower"], ["hashtag", "#"], ["heart", "Heart"], ["lightning-bolt", "Lightning Bolt"],
    ["like", "Like"], ["moon", "Moon"], ["music-note", "Music Note"], ["paw-print", "Paw Print"], ["percent", "%"],
    ["plus", "+"], ["question-mark", "?"], ["rocket", "Rocket"], ["smiley-face", "Smiley Face"], ["star", "Star"],
    ["sun", "Sun"], ["youtube", "YouTube"]
  ].map(([id, label]) => ({
    id, label, thumbnail: "", models: {
      raised: pencilPreviewModel(`design-raised-${id}.glb`),
      flush: pencilPreviewModel(`design-flush-${id}.glb`)
    }, supportsDesignColor: true,
    surchargeCents: 0, surchargeVariantId: "", enabled: PENCIL_ENABLE_LICENSED_DESIGNS
  })),

  preview: {
    // Upload only reduced-detail storefront previews, then paste Shopify CDN URLs here.
    pencilTip: {
      model: pencilPreviewModel("tip.glb"),
      tintMaterialNames: ["Graphite"],
      fixedMaterialColors: { PencilTipColor: "#E8DBB7" },
      position: [-0.50, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1]
    },
    blockShell: { model: pencilPreviewModel("block.glb"), tintMaterialNames: ["Block"], position: [0.65, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1] },
    metalBand: { model: pencilPreviewModel("band.glb"), fixedMaterialColors: { Metal: "#C0C0C0" }, position: [1.80, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1] },
    eraser: { model: pencilPreviewModel("eraser.glb"), tintMaterialNames: ["Eraser"], position: [2.62, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1] },
    endCapSingle: { model: pencilPreviewModel("end-cap-single.glb"), tintMaterialNames: ["EndCapPrimary"], position: [1.60, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1] },
    endCapMulticolor: { model: pencilPreviewModel("end-cap-multicolor.glb"), position: [1.60, 0, 0], rotation: [0, 0, 0], scale: [1, 1, 1] },
    blockAxis: "x",
    blockSpacing: 1.30,
    cameraPosition: [5, 4.5, 7],
    cameraTarget: [1.2, 0, 0],
    background: "#f5f3ee"
  }
};
